/**
 * Operadores aceitos: só a forma canônica do RSQL/FIQL. As formas alternativas
 * (`<`, `<=`, `>`, `>=`, `and`, `or`) são recusadas de propósito, para que um
 * filtro tenha uma única grafia.
 */
export const RSQL_OPERATORS = [
    '==',
    '!=',
    '=lt=',
    '=le=',
    '=gt=',
    '=ge=',
    '=in=',
    '=out=',
];
/** Operadores que recebem uma lista: `campo=in=(a,b)`. */
export const LIST_OPERATORS = ['=in=', '=out='];
//# sourceMappingURL=ast.js.map